// extracted by mini-css-extract-plugin
module.exports = {"root":"register_root__3wyMf","form":"register_form__TIvLF"};